import AppHeader from '../AppHeader'

export default {
  name: 'ability-question-new',
  data () {
    return {
      skillType: 'personal',
      title: '',
      questions: [
        {
          content: '',
          displayOrder: 1,
          answerContent1: '',
          answerContent2: '',
          answerContent3: '',
          answerContent4: ''
        }
      ],
      canValidate: true,
      savingFlag: false
    }
  },
  computed: {
    validation: function () {
      var v = {
        title: !!this.title,
        not_input: !!this.title
      }
      v.content = []
      v.answerContent1 = []
      v.answerContent2 = []
      v.answerContent3 = []
      v.answerContent4 = []
      v.content_all = true
      v.answerContent_all = true
      for (let index in this.questions) {
        let vc = !!(this.questions[index].content)
        let va1 = !!(this.questions[index].answerContent1)
        let va2 = !!(this.questions[index].answerContent2)
        let va3 = !!(this.questions[index].answerContent3)
        let va4 = !!(this.questions[index].answerContent4)
        v.content.push(vc)
        v.answerContent1.push(va1)
        v.answerContent2.push(va2)
        v.answerContent3.push(va3)
        v.answerContent4.push(va4)
        v.content_all &= vc
        v.answerContent_all &= va1
        v.answerContent_all &= va2
        v.answerContent_all &= va3
        v.answerContent_all &= va4
      }
      v.not_input = v.not_input && !!v.content.length && !!v.content_all && !!v.answerContent_all
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true })
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    onClickSave: function () {
      if (this.savingFlag) return false
      this.savingFlag = true
      this.$store.dispatch('ABILITY_QUESTION_CREATE', {
        data: {
          title: this.title,
          skillType: this.skillType,
          contents: this.questions
        }
      })
      .then(res => {
        this.$router.push({path: '/ability_question'})
      })
      .catch(err => console.log(err))
    },
    onClickCancel: function () {
      this.$router.push('/ability_question')
    },
    addContent: function () {
      let question = {
        content: null,
        displayOrder: this.questions.length + 1,
        answerContent1: '',
        answerContent2: '',
        answerContent3: '',
        answerContent4: ''
      }
      this.questions.splice(this.questions.length, 0, question)
    },
    deleteContent: function (index) {
      this.questions.splice(index, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/ability-question-new.js